import { render, staticRenderFns } from "./ModifySolarwindsBackupPackageModal.vue?vue&type=template&id=80cc4db6&"
import script from "./ModifySolarwindsBackupPackageModal.vue?vue&type=script&lang=js&"
export * from "./ModifySolarwindsBackupPackageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports